var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { computed, set } from '@ember/object';
import { readOnly } from '@ember/object/computed';
export const INITIAL_PAGE_SIZE = 40;
export const NEXT_PAGE_SIZE = 5;
let BankingUnitAccountPagination = (_dec = readOnly('bankingAccountApi.isLoading'), _dec2 = computed('unitOwnersFetched', 'bankingAccountApi.accounts'), _dec3 = computed('unitOwnersFetched', 'bankingAccountApi.partialAccounts'), _class = class BankingUnitAccountPagination extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "currentIndex", 0);
    _defineProperty(this, "nextIndex", INITIAL_PAGE_SIZE);
    _defineProperty(this, "unitOwners", []);
    // Should be "private" but it needs to be public to be used with `set` which we
    // need for the `accounts` computed property.
    _defineProperty(this, "unitOwnersFetched", []);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor, this);
    _initializerDefineProperty(this, "isLoading", _descriptor2, this);
  }
  get accounts() {
    let accounts = [];
    this.unitOwnersFetched.forEach(owner => {
      const ownerAccounts = this.bankingAccountApi.getAccountsForOwner(owner);
      accounts = [...accounts, ...ownerAccounts];
    });
    return accounts;
  }
  get partialAccounts() {
    let partialAccounts = [];
    this.unitOwnersFetched.forEach(owner => {
      const ownerPartialAccounts = this.bankingAccountApi.getPartialAccountsForOwner(owner);
      partialAccounts = [...partialAccounts, ...ownerPartialAccounts];
    });
    return partialAccounts;
  }
  configure(units) {
    const owners = units.map(unit => {
      return Owner.create({
        id: unit.token,
        type: OwnerType.UNIT
      });
    });
    // Reinitialize all cached values on configure,
    // which happens at page load
    this.currentIndex = 0;
    this.nextIndex = INITIAL_PAGE_SIZE;
    set(this, 'unitOwnersFetched', []);
    this.unitOwners = owners;
  }

  // Return the owners for the next page of accounts. We use this to optimize
  // account loading if we want to fetch a page of unit accounts along with other
  // accounts.
  nextPageToFetch() {
    const nextIndex = Math.min(this.nextIndex, this.unitOwners.length);
    return {
      nextIndex,
      owners: this.unitOwners.slice(this.currentIndex, nextIndex)
    };
  }
  async getNextPage() {
    if (this.currentIndex >= this.unitOwners.length) {
      return;
    }
    const {
      nextIndex,
      owners
    } = this.nextPageToFetch();
    await this.bankingAccountApi.listAccounts(owners);
    set(this, 'unitOwnersFetched', [...this.unitOwnersFetched, ...owners]);
    this.currentIndex = nextIndex;
    this.nextIndex = nextIndex + NEXT_PAGE_SIZE;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "accounts", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "accounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "partialAccounts", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "partialAccounts"), _class.prototype), _class);
export { BankingUnitAccountPagination as default };